import { nav } from "./nav";
import { hero } from "./hero";
import { dashboard } from "./dashboard";
import { faq } from "./faq";
import { footer } from "./footer";
import { pricing } from "./pricing";
import { howItWorks } from "./howItWorks";
import { favorites } from "./favorites";
import { memberProfile } from "./memberProfile";
import { incomingRequests } from "./incomingRequests";
import { migrated } from "./migrated";
import { countries } from "./countries";

export const common = {
  nav,
  hero,
  dashboard,
  faq,
  footer,
  pricing,
  howItWorks,
  favorites,
  memberProfile,
  incomingRequests,
  migrated,
  countries,
  corporate: {
    hero: {
      title: "Reinventar el viaje",
      subtitle: "Una visión ética, local y humana del turismo del mañana.",
    },
    mission: {
      badge: "Nuestra Misión",
      title: "Turismo justo",
      description:
        "Creemos que viajar debe ser accesible para todos, sin intermediarios costosos. DONKEY TRAVEL permite a los propietarios viajar libremente gracias al valor de su propia propiedad.",
    },
    philosophy: {
      badge: "Nuestra Filosofía",
      title: "Hecho en Francia y humano",
      description:
        "Arraigados en el Valle del Somme, defendemos un modelo artesanal frente a los gigantes tecnológicos. Sin algoritmos oscuros, solo sentido común y convivialidad.",
      values: {
        fair: {
          title: "Justo",
          desc: "0% de comisión en los intercambios. Solo una suscripción transparente.",
        },
        local: {
          title: "Arraigo Local",
          desc: "Orgullosos de nuestras raíces francesas, promovemos un turismo respetuoso.",
        },
        community: {
          title: "Comunitario",
          desc: "Un club privado de propietarios de confianza que comparten los mismos valores.",
        },
      },
    },
    team: {
      badge: "El equipo",
      title: "Apasionados a tu servicio",
      subtitle: "Detrás de la plataforma, humanos que aman viajar y compartir.",
      members: {
        ceo: {
          name: "Plük",
          role: "Creador de DONKEY TRAVEL • Desarrollador • Superhost de Airbnb desde hace 4 años",
          bio: "Durante años, he recibido viajeros en mis casas rurales, donde yo mismo podría haber ido si DONKEY TRAVEL hubiera existido. Por eso creé DONKEY TRAVEL: para permitir que los anfitriones se reciban entre sí y viajen de otra manera.",
        },
        cto: {
          name: "Marie Martin",
          role: "CTO",
          bio: "Arquitecta de la plataforma, garante de la seguridad.",
        },
        cmo: {
          name: "Sophie Bernard",
          role: "Responsable de Comunicación",
          bio: "La voz de DONKEY TRAVEL ante nuestra comunidad.",
        },
      },
    },
    investors: {
      badge: "Inversores",
      title: "Únete a la aventura",
      description:
        "DONKEY TRAVEL está en pleno crecimiento. Buscamos socios que compartan nuestra visión de un turismo sostenible y justo.",
      cta: "Contáctenos para invertir",
    },
  },
  trokOrigin: {
    badge: "Comprender el concepto",
    title: "¿Cómo funciona exactamente?",
    subtitle:
      "Un intercambio directo entre dos personas, sin intermediarios ni sistemas de puntos complicados",
    etymology: {
      title: "El origen de la palabra",
      historicalTitle: "Una práctica milenaria",
      text1:
        'La palabra "Troc" aparece en francés en el siglo XIV, derivada del verbo "troquer". Encuentra sus raíces en el español "trueque" y el valón "trouk", evocando la idea de intercambio directo.',
      text2:
        'Atestiguado desde 1364 bajo la forma "truke" en documentos anglonormandos, luego oficializado en 1464 en las cartas patentes de Luis XI: "para la venta, trueque o intercambio de dichas mercancías".',
      text3:
        "En DONKEY TRAVEL, hemos mantenido esta filosofía ancestral: intercambias directamente tu alojamiento con otro propietario. Sin moneda virtual, sin puntos que acumular. Solo un acuerdo entre dos humanos.",
      from: "Etimología",
      meaning: "Intercambiar directamente, de persona a persona",
      century14: "Siglo XIV",
      firstAttestation: "Primera atestación en francés",
      century15: "Siglo XV",
      officialUse: "Uso oficial por Luis XI",
      today: "Hoy",
      modernPractice: "Práctica moderna y colaborativa",
    },
    direct: {
      title: "Solo intercambio directo",
      description:
        "A diferencia de los sistemas de puntos o créditos, DONKEY TRAVEL funciona bajo el principio del trueque puro. Negocias directamente con otro propietario: tus noches a cambio de las suyas. Es la esencia misma del trueque tal como existe desde el siglo XIV.",
      result: "¡Intercambio directo validado!",
    },
    noTriangulation: {
      title: "Sin triangulación",
      description:
        "Sin sistema complejo donde A da a B que da a C. Aquí es simple: encuentras a alguien, negociáis juntos (fechas simultáneas o diferidas), intercambiáis. Punto final.",
      noPoints: "Sin puntos que contar",
    },
    meetHost: {
      title: "Conoce a otro anfitrion de Airbnb",
      description:
        "DONKEY TRAVEL no es solo descubrir un alojamiento o viajar. Es ante todo conocer a otro apasionado de la acogida, alguien que comparte tus valores de hospitalidad. El trueque siempre ha sido una práctica social antes que económica.",
      share: "Comparte tus experiencias de anfitrión",
      tips: "Intercambia tus mejores consejos",
      friendship: "Crea amistades duraderas",
      badge: "Comunidad de anfitriones",
      badgeSub: "Encuentros auténticos",
      step2Title: "2. Contrato amistoso en DONKEY TRAVEL",
      step2Desc:
        "Firman el contrato de intercambio directamente en la plataforma y reciben el PDF por correo electrónico. Todo es seguro y oficial.",
      contractSigned: "Contrato firmado y seguro",
      step3Title: "3. Marie llega a París (2 semanas después)",
      step3Desc:
        "Jean recibe a Marie calurosamente. Está impresionado: el apartamento está impecable, Marie respeta todo. ¡Qué diferencia con algunos viajeros de Airbnb! Discuten sus experiencias como anfitriones tomando un café.",
      step4Title: "4. Jean descubre Reims (6 meses después)",
      step4Desc:
        "Jean llega a la casa rural de Marie en Reims. ¡El entorno es magnífico! Marie lo invita a cenar, comen juntos y arreglan el mundo hablando de viajes, de Airbnb y de sus mejores anécdotas como anfitriones.",
      step5Title: "5. Una amistad duradera",
      step5Desc:
        "Marie y Jean siguen en contacto. Deciden intercambiar regularmente sus alojamientos. Más que un simple intercambio, ha nacido una verdadera amistad gracias a TRAVELTROK.",
      spiritTitle: "¡Ese es el espíritu DONKEY TRAVEL!",
      spiritDesc:
        "Intercambios auténticos entre propietarios apasionados, con respeto y convivencia. Sin puntos, sin triangulación, solo verdadero trueque a la antigua.",
    },
    negotiation: {
      badge: "Negociación lúdica",
      title: "¡Negocia como un juego!",
      description:
        "¿10 noches por 5? ¡Por qué no! Haz una oferta, recibe una contraoferta, encuentra un acuerdo. Todo con buen espíritu. Como en los tiempos de los primeros intercambios, la negociación es parte de la diversión.",
      marieProperty: "Casa rural en Reims",
      jeanProperty: "Apartamento en París",
      marieLocation: "En su casa rural en Reims",
      jeanLocation: "En su apartamento en París",
      marieAccepts: "Marie acepta la oferta",
      offers: "Oferta",
      proposes: "Propone",
      nights: "noches",
      status: {
        initial: "Marie hace una oferta...",
        counter: "¡Jean hace una contraoferta!",
        negotiate: "Marie negocia...",
        deal: "¡Trato hecho! 🎉",
      },
      chat: {
        msg1: "¡Te propongo {{marieNights}} noches en mi casa rural en Reims a cambio de {{jeanNights}} noches en París!",
        msg2: "Jean encuentra el alojamiento de Marie muy bien...",
        msg3: "¡Tu casa rural es magnífica! Soy simpático, te propongo {{jeanNights}} noches en París 😊",
        msg4: "¡Trato hecho! 🤝",
        msg5: "Marie mira las disponibilidades de Jean...",
      },
      nextStep: "Siguiente paso",
      restart: "Reiniciar",
      points: {
        flexible: "Negociación flexible",
        friendly: "Ambiente amistoso",
        fair: "Acuerdo justo",
      },
    },
    flexibility: {
      title: "Flexibilidad total",
      description:
        "A diferencia de los intercambios tradicionales, no necesitas encontrar a alguien que quiera tu alojamiento exactamente cuando tú quieres el suyo. ¡Acumula Noches y úsalos cuando quieras!",
    },
    example: {
      person1: "Marie",
      location1: "París, Francia",
      person2: "Jean",
      location2: "Lyon, Francia",
      result: "¡Intercambio exitoso!",
    },
  },
  exchange: {
    title: "¿Cómo funciona?",
    subtitle:
      "Un sistema simple y seguro para intercambiar tus alojamientos con total confianza",
    features: {
      secure: {
        title: "Intercambios seguros",
        description:
          "Todos los miembros son verificados y las reseñas garantizan la transparencia de cada intercambio.",
      },
      sync: {
        title: "Sincronización de calendario",
        description:
          "Sincroniza automáticamente tus disponibilidades con tu calendario de Airbnb existente.",
      },
      global: {
        title: "Red europea",
        description:
          "Accede a los miembros anfitriones en los países europeos disponibles en TRAVELTROK.",
      },
      chat: {
        title: "Mensajería integrada",
        description:
          "Comunícate directamente con otros propietarios para organizar tus intercambios.",
      },
      rating: {
        title: "Sistema de puntuación",
        description:
          "Consulta las reseñas y puntuaciones para elegir a tus compañeros de intercambio con confianza.",
      },
      savings: {
        title: "Ahorros garantizados",
        description:
          "Viaja gratis usando tus Noches en lugar de pagar alojamientos costosos.",
      },
    },
    steps: {
      title: "En 3 pasos simples",
      step1: {
        title: "Crea tu perfil",
        description:
          "Regístrate y añade la información de tu alojamiento de Airbnb en unos minutos.",
      },
      step2: {
        title: "Encuentra tu destino",
        description:
          "Explora los alojamientos disponibles y encuentra el destino de tus sueños.",
      },
      step3: {
        title: "Intercambia y viaja",
        description:
          "¡Propón un intercambio, confirma las fechas y disfruta de tu estancia gratis!",
      },
    },
  },
  worldMap: {
    title: "Top 20 de los países más activos",
    subtitle:
      "Descubre los países donde los intercambios de alojamiento son más populares hoy",
    description:
      "Nuestra comunidad crece cada día con nuevos propietarios en todo el mundo. Descubre dónde podrías viajar gratis.",
    badge: "Clasificación en tiempo real",
    properties: "alojamientos",
    cta: "Ver todos los destinos",
    exchangesToday: "Intercambios hoy",
    activeCountries: "Países activos",
    vsYesterday: "vs. ayer",
    fullRanking: "Clasificación completa",
    countries: {
      Guadeloupe: "Guadalupe",
      Martinique: "Martinica",
      Guyane: "Guayana Francesa",
      "La Réunion": "Reunión",
      Mayotte: "Mayotte",
      "Polynésie française": "Polinesia Francesa",
      "Nouvelle-Calédonie": "Nueva Caledonia",
      "Îles Canaries": "Islas Canarias",
      "Ceuta & Melilla": "Ceuta y Melilla",
      Madère: "Madeira",
      Açores: "Azores",
      Aruba: "Aruba",
      Curaçao: "Curazao",
      "Saint-Martin": "San Martín",
      Bermudes: "Bermudas",
      "Îles Caïmans": "Islas Caimán",
      Gibraltar: "Gibraltar",
      france: "Francia",
      spain: "España",
      italy: "Italia",
      usa: "Estados Unidos",
      uk: "Reino Unido",
      germany: "Alemania",
      portugal: "Portugal",
      netherlands: "Países Bajos",
      canada: "Canadá",
      australia: "Australia",
      belgium: "Bélgica",
      switzerland: "Suiza",
      greece: "Grecia",
      mexico: "México",
      brazil: "Brasil",
      austria: "Austria",
      croatia: "Croacia",
      thailand: "Tailandia",
      morocco: "Marruecos",
    },
  },
  calendar: {
    title: "Sincronización automática con Airbnb",
    subtitle: "Conecta tu calendario de Airbnb en un clic",
    description:
      "Tus disponibilidades se sincronizan automáticamente. Ya no necesitas gestionar dos calendarios por separado.",
    features: {
      sync: {
        title: "Sincronización bidireccional",
        description:
          "Tus calendarios de Airbnb y DONKEY TRAVEL se mantienen siempre actualizados automáticamente",
      },
      realtime: {
        title: "Actualizaciones en tiempo real",
        description:
          "Cada modificación se sincroniza instantáneamente en ambas plataformas",
      },
      smart: {
        title: "Gestión inteligente",
        description:
          "Evita las dobles reservas gracias a nuestro sistema avanzado de sincronización",
      },
    },
    cta: "Conectar mi calendario",
  },
  airbnb: {
    title: "¿Ya eres propietario en Airbnb?",
    subtitle: "Únete a DONKEY TRAVEL y comienza a viajar gratis",
    description:
      "Importa automáticamente la información de tu alojamiento de Airbnb y comienza a intercambiar hoy mismo.",
    features: {
      verification: {
        title: "Verificación automática de tu perfil",
      },
      import: {
        title: "Importación de tus fotos y descripciones",
      },
      trust: {
        title: "Únete a una comunidad de confianza",
      },
    },
    cta: "Conectar mi Airbnb",
  },
  membersMap: {
    title: "Mapa de miembros",
    searchPlaceholder: "Buscar un destino, ciudad...",
    filters: "Filtros",
    radius: "Radio",
    radiusAuto: "Automático",
    reset: "Reiniciar",
    filterPets: "Mascotas permitidas",
    filterVerified: "Anfitriones verificados",
    filterRating: "4.8+",
    filterAllTypes: "Todos los tipos",
    oneTraveler: "1 viajero",
    multipleTravelers: "{{count}} viajeros",
    dates: "Fechas",
    addDates: "Añadir fechas",
    startDate: "Salida",
    endDate: "Regreso",
    listingsTitle: "Alojamientos",
    listingsSubtitle: "Selecciona para ver en el mapa.",
    pagination: "{{current}} / {{total}}",
    clearFilters: "Borrar filtros",
    guestsShort: "p.",
    bedroomsShort: "hab.",
    surfaceAreaUnit: "m²",
    perNight: "/ noche",
    online: "En línea",
    offline: "Desconectado",
    verified: "Verificado",
    favorite: "Favorito",
    favorites: "Favoritos",
    members: "Miembros",
    exchanges: "intercambios",
    rooms: "habitaciones",
    mapTitle: "Mapa interactivo de miembros DONKEY TRAVEL",
    countries: "Países",
    results: "resultados",
    viewProfile: "Ver perfil",
    proposeExchange: "Proponer un intercambio",
    showFavoritesOnly: "Mostrar solo favoritos",
    advancedSearch: "Búsqueda avanzada",
    refineSearch: "Refinar su búsqueda",
    activeFilter: "filtro activo",
    activeFilters: "filtros activos",
    availabilityDates: "Fechas de disponibilidad",
    quickPeriods: "Periodos rápidos",
    thisMonth: "Este mes",
    nextMonth: "Mes próximo",
    next3Months: "Próximos 3 meses",
    summer: "Verano",
    autumn: "Otoño",
    winter: "Invierno",
    arrival: "Llegada",
    departure: "Salida",
    flexibleDates: "Fechas flexibles",
    clear: "Borrar",
    propertyTypeTitle: "Tipo de alojamiento",
    apartment: "Apartamento",
    house: "Casa",
    villa: "Villa",
    loft: "Loft",
    capacityAndRooms: "Capacidad y habitaciones",
    numberOfTravelers: "Número de viajeros",
    all: "Todos",
    numberOfRooms: "Número de habitaciones",
    minimumSurface: "Superficie mínima",
    equipments: "Equipamiento",
    wifi: "Wi‑Fi",
    pool: "Piscina",
    parking: "Aparcamiento",
    airConditioning: "Aire acondicionado",
    garden: "Jardín",
    terrace: "Terraza",
    fireplace: "Chimenea",
    barbecue: "Barbacoa",
    bike: "Bicicleta",
    sauna: "Sauna",
    gym: "Gimnasio",
    washingMachine: "Lavadora",
    statusAvailability: "Estado y disponibilidad",
    onlineAvailability: "Disponibilidad en línea",
    onlineOnly: "En línea",
    verifiedMembersOnly: "Solo miembros verificados",
    ratingExperience: "Nota y experiencia",
    minimumRating: "Nota mínima",
    minimumExchanges: "Intercambios mínimos",
    matchingMembers: "miembros correspondientes",
    matchingMember: "miembro correspondiente",
    seeResults: "Ver los",
    result: "resultado",
    resetAllFilters: "Reiniciar todos los filtros",
    rating: "Nota",
    travelers: "Viajeros",
    contact: "Contactar",
    searchMemberCity: "Buscar un miembro, ciudad, país...",
    noFavorite: "Ningún favorito",
    addFavoritesHint:
      "Añade miembros a tus favoritos haciendo clic en el corazón",
    noMemberFound: "Ningún miembro encontrado",
    tryModifyFilters: "Intenta modificar tus filtros",
    viewAllMembers: "Ver todos los miembros",
    modifyFilters: "Modificar los filtros",
    favoritesOnly: "Solo favoritos",
    addToFavorites: "Añadir a favoritos",
    removeFromFavorites: "Quitar de favoritos",
    loading: "Cargando...",
    sortBy: "Ordenar por",
    relevance: "Relevancia",
    newest: "Más recientes",
    noResults: "Ningún resultado encontrado",
    tryDifferentFilters: "Intenta ajustar tus filtros de búsqueda",
    membersList: "Lista de miembros",
    membersFound: "miembros encontrados",
    visibleMembers: "Miembros visibles",
    legend: "Leyenda",
    availableProperty: "Alojamiento disponible",
    selected: "Seleccionado",
    visibleByAll: "Visible para todos",
    allMembersSeeYou: "Todos los miembros te ven",
    targetedMode: "Modo enfocado",
    countriesSelected: "países seleccionados",
    countrySelected: "país seleccionado",
    myVisibility: "Mi visibilidad",
    whoCanSee: "¿Quién puede ver mi alojamiento en el mapa?",
    visibleByAllTitle: "Visible para todos",
    visibleByAllDesc:
      "Todos los miembros de la comunidad pueden ver tu alojamiento y proponerte un intercambio.",
    visibleByAllHint: "Máxima visibilidad y oportunidades",
    active: "ACTIVO",
    targetedModeTitle: "Modo enfocado",
    targetedModeDesc:
      "Solo los miembros de los países que buscas pueden ver tu alojamiento. Discreción máxima.",
    targetedModeHint: "Solo ves y eres visto por tus destinos",
    myDesiredDestinations: "Mis destinos deseados",
    clearAll: "Borrar todo",
    searchCountry: "Buscar un país...",
    member: "miembro",
    membersCount: "miembros",
    noCountryFound: "Ningún país encontrado",
    targetedInfoTitle: "Tu alojamiento solo aparecerá para los miembros en",
    targetedInfoDesc: "Los demás no te verán en el mapa.",
    targetedExample:
      "Ejemplo: si solo quieres ir a Holanda, solo los miembros holandeses verán tu perfil.",
    selectAtLeastOneCountry:
      "Selecciona al menos un país para activar el modo enfocado.",
    propertyTypes: {
      appartement: "Apartamento",
      maison: "Casa",
      villa: "Villa",
      loft: "Loft",
      luxe: "Lujo",
      insolite: "Insólito",
    },
    pricePerNight: "PRECIO POR NOCHE (€)",
    min: "Mín",
    max: "Máx",
    sortResults: "ORDENAR RESULTADOS",
    sort: {
      recommended: "✨ Recomendados",
      priceAsc: "💶 Precio creciente",
      priceDesc: "💎 Precio decreciente",
    },
    amenitiesTitle: "EQUIPAMIENTO",
    amenitiesTabs: {
      all: "TODOS",
      essentials: "ESENCIALES",
      features: "CONFORT",
      location: "UBICACIÓN",
      safety: "SEGURIDAD",
    },
  },
  amenities: {
    wifi: "Wifi",
    tv: "Televisión",
    kitchen: "Cocina",
    washing_machine: "Lavadora",
    ac: "Aire acondicionado",
    heating: "Calefacción",
    workspace: "Espacio de trabajo",
    iron: "Plancha",
    hair_dryer: "Secador de pelo",
    pool: "Piscina",
    hottub: "Jacuzzi",
    patio: "Terraza",
    bbq: "Barbacoa",
    parking: "Aparcamiento gratuito",
    gym: "Gimnasio",
    fireplace: "Chimenea",
    breakfast: "Desayuno",
    beachfront: "Frente a la playa",
    ski_in_out: "Pie de pistas",
    lake_access: "Acceso al lago",
    smoke_detector: "Detector de humo",
    first_aid: "Botiquín",
    fire_extinguisher: "Extintor",
  },
  destinations: {
    title: "Destinos",
    searchPlaceholder: "Buscar una destino...",
    destinationsFound: "destinos encontrados",
    noResults: "Ningún resultado",
    tryDifferentSearch: "Intenta otra búsqueda",
    sortMembers: "Más miembros",
    sortProperties: "Más alojamientos",
    sortName: "Nombre (A-Z)",
    all: "Todos",
    members: "miembros",
    properties: "alojamientos",
    explore: "Explorar este destino",
    stats: {
      destinations: "Destinos",
      members: "Miembros",
      properties: "Alojamientos",
      countries: "Países",
    },
    countriesIn: "Países en",
    selectCountry: "— selecciona un país para filtrar",
    continents: {
      Europe: "Europa",
      "Amérique du Nord": "América del Norte",
      "Amérique du Sud": "América del Sur",
      Asie: "Asia",
      Afrique: "África",
      Océanie: "Oceanía",
    },
    countries: {
      Turquie: "Turquía",
      France: "Francia",
      "Pays-Bas": "Países Bajos",
      "Royaume-Uni": "Reino Unido",
      Espagne: "España",
      Italie: "Italia",
      Tchéquie: "República Checa",
      Grèce: "Grecia",
      Portugal: "Portugal",
      Autriche: "Austria",
      Écosse: "Escocia",
      Hongrie: "Hungría",
      Croatie: "Croacia",
      Danemark: "Dinamarca",
      Suède: "Suecia",
      Suisse: "Suiza",
      Belgique: "Bélgica",
      Norvège: "Noruega",
      Irlande: "Irlanda",
      Pologne: "Polonia",
      Finlande: "Finlandia",
      Islande: "Islandia",
      Roumanie: "Rumania",
      Monténégro: "Montenegro",
      "États-Unis": "Estados Unidos",
      Canada: "Canadá",
      Mexique: "México",
      "Costa Rica": "Costa Rica",
      Cuba: "Cuba",
      "Rép. Dominicaine": "República Dominicana",
      Guatemala: "Guatemala",
      Brésil: "Brasil",
      Argentine: "Argentina",
      Pérou: "Perú",
      Colombie: "Colombia",
      Chili: "Chile",
      Équateur: "Ecuador",
      Uruguay: "Uruguay",
      Bolivie: "Bolivia",
      Chine: "China",
      Thaïlande: "Tailandia",
      Indonésie: "Indonesia",
      Vietnam: "Vietnam",
      "Corée du Sud": "Corea del Sur",
      Inde: "India",
      Cambodge: "Camboya",
      Jordanie: "Jordania",
      Maldives: "Maldivas",
      "Sri Lanka": "Sri Lanka",
      Népal: "Nepal",
      Philippines: "Filipinas",
      Ouzbékistan: "Uzbekistán",
      Égypte: "Egipto",
      Maroc: "Marruecos",
      "Afrique du Sud": "Sudáfrica",
      Tanzanie: "Tanzania",
      Kenya: "Kenia",
      Sénégal: "Senegal",
      Madagascar: "Madagascar",
      Tunisie: "Túnez",
      Zimbabwe: "Zimbabue",
      Namibie: "Namibia",
      "Île Maurice": "Mauricio",
      Rwanda: "Ruanda",
      Australie: "Australia",
      "Nouvelle-Zélande": "Nueva Zelanda",
      "Polynésie française": "Polinesia Francesa",
      Fidji: "Fiyi",
      "Nouvelle-Calédonie": "Nueva Caledonia",
      Samoa: "Samoa",
    },
    cities: {
      Paris: "París",
      "Mont Saint-Michel": "Monte Saint-Michel",
      Marseille: "Marsella",
      Amsterdam: "Ámsterdam",
      Londres: "Londres",
      Barcelone: "Barcelona",
      Madrid: "Madrid",
      Venise: "Venecia",
      Rome: "Roma",
      "Côte Amalfitaine": "Costa Amalfitana",
      Prague: "Praga",
      Santorin: "Santorini",
      Athènes: "Atenas",
      Lisbonne: "Lisboa",
      Porto: "Oporto",
      Vienne: "Viena",
      Édimbourg: "Edimburgo",
      Budapest: "Budapest",
      Dubrovnik: "Dubrovnik",
      Copenhague: "Copenhague",
      Stockholm: "Estocolmo",
      Zermatt: "Zermatt",
      Bruges: "Brujas",
      Bergen: "Bergen",
      Dublin: "Dublín",
      Cracovie: "Cracovia",
      Helsinki: "Helsinki",
      Reykjavik: "Reikiavik",
      Bucarest: "Bucarest",
      Kotor: "Kotor",
      "New York": "Nueva York",
      "San Francisco": "San Francisco",
      "Los Angeles": "Los Ángeles",
      Miami: "Miami",
      Hawaï: "Hawái",
      Vancouver: "Vancouver",
      Montréal: "Montreal",
      Toronto: "Toronto",
      Banff: "Banff",
      Québec: "Quebec",
      Cancún: "Cancún",
      "Mexico City": "Ciudad de México",
      "San José": "San José",
      "La Havane": "La Habana",
      "Punta Cana": "Punta Cana",
      Antigua: "Antigua",
      "Buenos Aires": "Buenos Aires",
      "Rio de Janeiro": "Río de Janeiro",
      "São Paulo": "São Paulo",
      "Machu Picchu": "Machu Picchu",
      Lima: "Lima",
      Carthagène: "Cartagena",
      Bogotá: "Bogotá",
      Santiago: "Santiago",
      Quito: "Quito",
      Montevideo: "Montevideo",
      "La Paz": "La Paz",
      Tokyo: "Tokio",
      Kyoto: "Kioto",
      Pékin: "Pekín",
      Shanghai: "Shanghái",
      "Hong Kong": "Hong Kong",
      Bangkok: "Bangkok",
      "Chiang Mai": "Chiang Mai",
      Bali: "Bali",
      "Hô Chi Minh-Ville": "Ciudad Ho Chi Minh",
      Séoul: "Seúl",
      "Angkor Wat": "Angkor Wat",
      Colombo: "Colombo",
      Katmandou: "Katmandú",
      Manille: "Manila",
      Samarcande: "Samarcanda",
      Petra: "Petra",
      "Le Caire": "El Cairo",
      Marrakech: "Marrakech",
      Chefchaouen: "Chefchaouen",
      "Le Cap": "Ciudad del Cabo",
      Johannesburg: "Johannesburgo",
      Zanzibar: "Zanzíbar",
      "Safari Masai Mara": "Safari Masái Mara",
      Nairobi: "Nairobi",
      Dakar: "Dakar",
      Antananarivo: "Antananarivo",
      Tunis: "Túnez",
      "Chutes Victoria": "Cataratas Victoria",
      Windhoek: "Windhoek",
      "Île Maurice": "Mauricio",
      Kigali: "Kigali",
      Sydney: "Sídney",
      Melbourne: "Melbourne",
      "Grande Barrière de Corail": "Gran Barrera de Coral",
      Auckland: "Auckland",
      Queenstown: "Queenstown",
      "Bora Bora": "Bora Bora",
      Fidji: "Fiyi",
      Nouméa: "Numea",
      Apia: "Apia",
      "Baie d'Halong": "Bahía de Ha Long",
      Maldives: "Maldivas",
    },
  },
  story: {
    badge: "Una historia real",
    title: "Chloé & Hugo: el trueque perfecto",
    subtitle:
      "Cuando una parisina cansada de la ciudad encuentra a un campesino que sueña con París...",
    chloé: {
      aptAlt: "Apartamento de Chloé en París",
      quotaExceeded: "¡Cuota de Airbnb superada!",
      role: "Anfitriona de Airbnb en París",
      speech1:
        'He <strong class="text-red-600">superado mi cuota de 120 noches</strong>... Imposible alquilar. Y francamente, estoy harta del ruido de París. 😩',
      nightsTag: "120/120 noches",
      tiredTag: "Cansada de París",
      dreamsOf: "Chloé sueña con...",
      dreamTitle: "La calma del campo",
      dreamDesc: "Verde, silencio, una sauna... ¡el paraíso!",
      searching: "Busca una casa rural",
      findsLuc: "¡Encuentra a Hugo!",
      speech2:
        "¡Por fin calma! La sauna después de un paseo por el bosque es la <strong>felicidad absoluta</strong>. 🌿✨",
      review:
        "¡La casa rural de Hugo es un pequeño paraíso! La sauna después de un paseo por el bosque es la felicidad. ¡Nos hemos hecho amigos! Recomiendo al 200%.",
    },
    hugo: {
      giteAlt: "Casa rural de Hugo en el campo",
      available: "Disponible todo el año",
      location: "Campo, Francia",
      role: "Anfitrión de Airbnb en el campo",
      speech1:
        'Mi casa rural tiene <strong class="text-sage-600">jardín, sauna y sillón de masaje</strong>... pero no aguanto más el campo. ¡Sueño con París! 🗼',
      dreamsOf: "Hugo sueña con...",
      dreamTitle: "Las luces de París",
      dreamDesc: "Museos, cafés, la Torre Eiffel... ¡por fin!",
      searching: "Busca un apartamento en París",
      findsMaya: "¡Encuentra a Chloé!",
      speech2:
        "¡París, por fin! El Louvre, los bistros, los tejados... ¡es <strong>mágico</strong>! 🗼🥐",
      review:
        "¡El apartamento de Chloé es increíble, con vistas a los tejados de París! Y todo sin tocar su cuota. ¡El trueque es genial!",
    },
    tags: {
      garden: "Jardín",
      sauna: "Sauna",
      massage: "Masaje",
      countryside: "Campo",
      bigGarden: "Gran jardín",
      restaurants: "Restaurantes",
      museums: "Museos",
    },
    match: {
      spark: "¡El flechazo!",
      title: "Descubren DONKEY TRAVEL",
      perfect: "¡Coincidencia perfecta!",
    },
    quota: {
      title: "Fuera de cuota Airbnb = ¡100% gratis!",
      description:
        "La estancia de Hugo no afecta a la cuota de Chloé. Es un intercambio, no un alquiler. ¡Todos ganan!",
      totalCost: "Coste total",
      quotaNight: "Noche cuota",
    },
    happyEnd: {
      title: "¡Todo el mundo feliz! 🎊",
      subtitle:
        "Chloé y Hugo se han hecho amigos. Comparten sus trucos de anfitrión y ya planean un próximo intercambio.",
      exchangeSuccess: "Intercambio exitoso",
      newFriendship: "Nueva amistad",
      outsideQuota: "Fuera de cuota",
      free: "100% gratis",
    },
  },
  messaging: {
    messages: "Mensajes",
    searchPlaceholder: "Buscar una conversación...",
    all: "Todos",
    unread: "No leídos",
    archived: "Archivados",
    online: "En línea",
    offline: "Desconectado",
    messagePlaceholder: "Escribir un mensaje...",
    writeMessage: "Escribir un mensaje",
    sending: "Enviando...",
    characters: "caracteres",
    noConversation: "Ninguna conversación",
    notificationMessage: "Nuevo mensaje",
    quickActions: "Acciones rápidas",
    proposeExchange: "Proponer un intercambio",
    proposeExchangeTitle: "Propuesta de intercambio",
    checkAvailability: "Comprobar disponibilidades",
    report: "Denunciar",
    hisProperty: "Su alojamiento",
    rooms: "habitaciones",
    guests: "viajeros",
    verifiedOwner: "Propietario verificado",
    viewAirbnbListing: "Ver anuncio Airbnb",
    details: "Detalles",
    desiredDates: "Fechas deseadas",
    arrival: "Llegada",
    departure: "Salida",
    period: "Periodo",
    duration: "Duración",
    nights: "noches",
    numberOfTravelers: "Número de viajeros",
    traveler: "viajero",
    travelers: "viajeros",
    person: "persona",
    persons: "personas",
    dateFlexibility: "Flexibilidad de fechas",
    exactDates: "Fechas exactas",
    flex1to2: "± 1-2 días",
    flex3to5: "± 3-5 días",
    flexWeek: "± 1 semana",
    personalMessage: "Mensaje personal",
    summary: "Resumen",
    termsAccept: "Acepto las condiciones de intercambio de DONKEY TRAVEL",
    sendProposal: "Enviar la propuesta",
    proposalSent: "¡Propuesta enviada!",
    proposalSentMessage: "Tu propuesta ha sido enviada con éxito",
    close: "Cerrar",
    today: "Hoy",
    selectConversation: "Selecciona una conversación",
    selectConversationHint: "Elige un propietario para comenzar a chatear",
  },
  destination_introuvable: `Destino no encontrado`,
  cette_destination_n_apos_existe_pas_ou_a__t__d_pla: `Este destino no existe o ha sido movido.`,
  retour_aux_destinations: `Volver a destinos`,
  pr_t___d_couvrir_: `Listo para descubrir`,
  r_server_ce_s_jour: `Reserva esta estancia`,
  explorer_d_apos_autres_destinations: `Explora otros destinos`,
  acc_s_r_serv_: `Acceso reservado`,
  europe_unique: `Europa única`,
  "50eur_an_pour__changer_dans_toute_l_europe_": `50EUR/año para cambiar en toda Europa.`,
  lancement_2026: `Lanzamiento 2026`,
  club_d__change_h_tes_airbnb: `Club de intercambio de anfitriones de Airbnb`,
  optimisez_vos_p_riodes_creuses_gr_ce_aux__changes: `Optimice sus periodos valle gracias a los intercambios`,
  rejoindre_le_club: `Únete al club`,
  trouver_un_h_te: `Encuentra un anfitrión`,
  r_serv__aux_h_tes_traveltrok: `Reservado para huéspedes de DONKEY TRAVEL`,
  voyagez_gratuitement_gr_ce___votre_logement: `Viaja gratis con tu alojamiento`,
  accueillez_des_membres_et_faites_vous_accueillir_e: `Bienvenidos miembros y sean bienvenidos nuevamente. Un intercambio sencillo, directo y sin efectivo entre propietarios.`,
  devenir_h_te: `Conviértete en anfitrión`,
  comment__a_marche__: `¿Cómo funciona?`,
  amis_partageant_un_repas_en_corse: `Amigos compartiendo una comida en Córcega`,
  _nous_avons__chang__notre_maison___lyon_contre_une: `"Cambiamos nuestra casa en Lyon por una villa en Córcega. Coste: 0 €."`,
  sophie___marc__membres_depuis_2023: `Sophie & Marc, miembros desde 2023`,
  pas_de_monnaie__pas_de_points__juste_un_accord_ent: `Sin monedas, sin puntos. Sólo un acuerdo entre dos propietarios. Yo vengo a tu casa, tú vienes a mi casa.`,
  "1__accord_mutuel": `1. Acuerdo mutuo`,
  vous_trouvez_un_membre_qui_vous_pla_t_et_vous_vous: `Encuentras un miembro que te gusta y aceptas intercambiar alojamiento.`,
  "2__flexibilit__totale": `2. Flexibilidad total`,
  "3__z_ro_comptabilit_": `3. Contabilidad cero`,
  pas_de_points___compter__juste_le_plaisir_de_parta: `No hay puntos para contar. Simplemente el placer de compartir y conocer.`,
  pourquoi_les_h_tes_adorent_ce_syst_me__: `¿Por qué a los anfitriones les encanta este sistema?`,
  plus_qu__une__conomie__c__est_une_nouvelle_fa_on_d: `Más que una economía, es una nueva forma de viajar.`,
  "0__de_frais": `0€ honorarios`,
  les__changes_sont_totalement_gratuits__pas_de_frai: `Los intercambios son completamente gratuitos. Sin gastos de servicio ni de limpieza (a menos que se acuerde específicamente).`,
  confiance_totale: `Confianza total`,
  seuls_les_h_tes_v_rifi_s_peuvent__changer__vous_ac: `Sólo los hosts verificados pueden comerciar. Estás dando la bienvenida a alguien que conoce el valor de la vivienda.`,
  simplicit_: `Simplicidad`,
  oubliez_la_valeur_des_points__une_nuit_est_une_nui: `Olvídate del valor de los puntos. Una noche es una noche. El intercambio se basa en la confianza entre anfitriones.`,
  rejoignez_la_communaut__des_h_tes: `Únete a la comunidad anfitriona`,
  rejoignez_la_communaut__et_commencez____changer_: `Únase a la comunidad y comience a chatear.`,
  commencer_maintenant: `Empezar ahora`,
  pr_nom_invalide: `Nombre no válido`,
  nom_invalide: `Nombre no válido`,
  email_invalide: `Correo electrónico no válido`,
  s_lectionne_un_pays: `Seleccione un país`,
  s_lectionne_un_mode_tarifaire: `Seleccione un método de fijación de precios`,
  s_lectionne_ton_usage: `Selecciona tu uso`,
  tu_dois_accepter_les_conditions: `Debes aceptar las condiciones`,
  france: `Francia`,
  belgique: `Bélgica`,
  suisse: `Suiza`,
  canada: `Canadá`,
  allemagne: `Alemania`,
  espagne: `España`,
  italie: `Italia`,
  portugal: `Portugal`,
  royaume_uni: `Reino Unido`,
  _tats_unis: `Estados Unidos`,
  autre: `Otros`,
  merci_de_corriger_les_champs_en_erreur_: `Por favor corrija los campos incorrectos.`,
  une_erreur_est_survenue__r_essaie_dans_quelques_in: `Ha ocurrido un error. Inténtalo de nuevo en unos momentos.`,
  compte_cr___avec_succ_s: `Cuenta creada exitosamente`,
  tu_recevras_un_email_pour_finaliser_ton_profil_voy: `Recibirás un correo electrónico para finalizar tu perfil de viajero/anfitrión.`,
  cr_er_un_autre_compte: `Crear otra cuenta`,
  activation_traveltrok: `Activación DONKEY TRAVEL`,
  choisis_ton_mode__voyageur__h_te__ou_usage_mixte_: `Elige tu modalidad: viajero, anfitrión o uso mixto.`,
  pr_nom: `Nombre`,
  jeanne: `Jane`,
  nom: `Nombre`,
  durand: `Durand`,
  email: `Correo electrónico`,
  jeanne_email_com: `jeanne@correo electrónico.com`,
  t_l_phone__optionnel_: `Teléfono (opcional)`,
  pays: `País`,
  choisir_un_pays: `Elige un país`,
  mode_tarifaire: `Método de fijación de precios`,
  voyageur: `Viajero`,
  nuit: `noche`,
  h_te: `Anfitrión`,
  pro_multi_logements: `Pro multivivienda`,
  mois: `mes`,
  usage_principal: `Uso principal`,
  je_voyage_principalement: `Viajo principalmente`,
  je_loue_principalement: `Principalmente alquilo`,
  je_fais_les_deux: `Hago ambas`,
  nombre_de_logements: `Número de alojamientos`,
  logement: `alojamiento`,
  logements: `alojamiento`,
  a: `un`,
  j_accepte_les_conditions_d_utilisation_et_la_polit: `Acepto los términos de uso y política de privacidad.`,
  cr_ation_en_cours___: `Creación en curso...`,
  cr_er_mon_compte_traveltrok: `Crear mi cuenta DONKEY TRAVEL`,
  r_servation_de_logements: `Reserva de alojamiento`,
  support_h_te_prioritaire: `Soporte prioritario para anfitriones`,
  carte___filtres_avanc_s: `Mapa + filtros avanzados`,
  flux_de_r_servation__tape_par__tape: `Flujo de reserva paso a paso`,
  couverture_dommages_assistance: `Cobertura de daños/asistencia`,
  multi_logements___reporting: `Viviendas múltiples + informes`,
  accueil: `Inicio`,
  tarifs: `Precios`,
  "0__commission_pour_les_h_tes": `0% de comisión para anfitriones`,
  r_volution_traveltrok: `Revolución DONKEY TRAVEL`,
  gardez_100__de_ce_que_vous_gagnez: `Conserva el 100% de lo que ganas`,
  simple: `Sencillo`,
  tu_connais_ton_co_t_avant_de_r_server__aucun_effet: `Conoces tu coste antes de reservar. Sin sorpresas al pagar.`,
  honn_te: `Honesto`,
  le_m_me_principe_pour_tous__voyageur_et_h_te_sont_: `El mismo principio para todos: viajero y anfitrión son tratados con la misma regla.`,
  utile: `Útil`,
  je_suis_voyageur: `Soy un viajero`,
  je_suis_h_te: `Soy anfitrión`,
  j_ai_plusieurs_logements: `Tengo varios alojamientos`,
  simulateur_comparatif_host: `Simulador de host comparativo`,
  compare_booking__airbnb_et_traveltrok_avec_tes_pro: `Compara Booking, Airbnb y DONKEY TRAVEL con tus propias cifras.`,
  nombre_de_nuits: `Número de noches`,
  property_price___night__eur_: `Precio de la propiedad / noche (EUR)`,
  autres_frais__m_nage__accueil__linge_____eur: `Otros costes (limpieza, recepción, ropa de cama, etc.) EUR`,
  option___qui_paie_les_frais__5____: `Opción: ¿Quién paga las tarifas (5%)?`,
  standard__recommand__: `Estándar (recomendado)`,
  pro___attractivit_: `Pro / Atractivo`,
  le_voyageur_paie_5__en_plus__vous_touchez_100__du_: `El viajero paga un 5% más. Recibes el 100% del precio.`,
  vous_payez_les_5___le_prix_affich__au_voyageur_est: `Pagas el 5%. El precio mostrado al viajero es neto.`,
  base_de_calcul: `Base de cálculo`,
  nuit_s_: `noche(s)`,
  autres_frais: `Otros costos`,
  montant_total_avant_commissions: `Importe total antes de comisiones`,
  plateforme: `Plataforma`,
  frais_h_te: `Tarifas de anfitrión`,
  frais_voyageur: `Tarifas de viajero`,
  total_voyageur: `Viajero total`,
  net_h_te: `Anfitrión de red`,
  avantage_fiscal___pro: `Ventajas fiscales y profesionales`,
  consultez_votre_expert_comptable_: `Consulte a su contador.`,
  diff_rence_h_te__claire_et_vendeuse: `Diferencia de anfitrión: clara y comercial`,
  frais_h_te___an: `Tarifas de anfitrión / año`,
  _conomie_compar_e___booking: `Economía en comparación con Booking`,
  _conomie_vs_airbnb: `Economía frente a Airbnb`,
  exemple_typique_sur_1_an__h_te_: `Ejemplo típico durante 1 año (anfitrión)`,
  nuits_r_serv_es: `Noches reservadas`,
  s_jours___an: `Estancias / año`,
  chiffre_d_affaires_annuel: `Volumen de negocios anual`,
  frais_traveltrok: `Tarifas de DONKEY TRAVEL`,
  frais_booking__15__: `Gastos de reserva (15%)`,
  frais_airbnb__15_5__: `Tarifas de Airbnb (15,5%)`,
  net_h_te_traveltrok: `Anfitrión de red DONKEY TRAVEL`,
  comparatif_des_modes: `Comparación de modos`,
  ce_que_tu_actives_selon_ton_usage_traveltrok_: `Lo que activas según tu uso de TRAVELTROK.`,
  fonction: `Función`,
  pro: `Profesional`,
  cr_er_ton_compte_et_ton_mode_d_usage: `Crea tu cuenta y tu modo de uso`,
  choisis_si_tu_d_marres_en_voyageur__h_te__ou_les_d: `Elige si empiezas como viajero, anfitrión o ambos. Puedes cambiar en cualquier momento.`,
  location_simple_c_t__voyageur: `Alquiler individual del lado del pasajero`,
  recherche__filtres__r_servation_rapide_et_co_t_tra: `Búsqueda, filtros, reserva rápida y coste transparente.`,
  gestion_h_te_simplifi_e: `Gestión de host simplificada`,
  publie_ton_logement__g_re_ton_calendrier_et_r_pond: `Publica tu alojamiento, gestiona tu calendario y responde rápidamente a las solicitudes.`,
  couverture_incluse_pour_le_voyageur_et_pour_l_h_te: `Cobertura incluida para el viajero y el anfitrión.`,
  support_op_rationnel: `Apoyo operativo`,
  accompagnement_en_cas_de_litige__annulation_ou_bes: `Soporte en caso de disputa, cancelación o necesidad de mediación.`,
  faq_tarifs: `Preguntas frecuentes sobre precios`,
  vraiment_0__de_commission_pour_l_h_te__: `¿Realmente 0% de comisión para el anfitrión?`,
  oui__l_h_te_re_oit_100__du_prix_qu_il_fixe__aucun_: `Sí. El anfitrión recibe el 100% del precio que fijó. Sin tarifas de servicio, sin tarifas de procesamiento.`,
  combien_paie_le_voyageur__: `¿Cuánto paga el viajero?`,
  le_voyageur_paie_une_commission_de_5__sur_le_monta: `El viajero paga una comisión del 5% sobre el importe del alquiler. Esto cubre los costos de funcionamiento, seguro y soporte.`,
  puis_je__changer_mon_logement_gratuitement__: `¿Puedo cambiar mi alojamiento gratis?`,
  oui___si_vous__tes_h_te__vous_pouvez__changer_votr: `Sí ! Si eres anfitrión, podrás intercambiar tu alojamiento con otros miembros sin ningún tipo de comisión (0€).`,
  pourquoi_ce_mod_le_est_il_moins_cher__: `¿Por qué este modelo es más barato?`,
  en_ne_prenant_que_5__au_total__contre_15____20__ai: `Al aceptar solo el 5 % en total (en comparación con el 15 % o el 20 % en otros lugares), hacemos que los viajes sean más accesibles y pagamos mejor a los anfitriones.`,
  pr_t___activer_ton_mode_traveltrok__: `¿Listo para activar tu modo DONKEY TRAVEL?`,
  voyageur__h_te__ou_hybride__commence_avec_une_logi: `Viajero, anfitrión o híbrido: comienza con una lógica clara y costos controlados.`,
  cr_er_mon_compte: `Crear mi cuenta`,
  explorer_les_logements: `Explorar alojamiento`,
  donn_es_personnelles: `Datos personales`,
  politique_de_confidentialit_: `Política de privacidad`,
  rejoignez_notre_communaut__et_r_servez_un_logement: `Únase a nuestra comunidad y reserve alojamiento en {{city}} con tarifas fijas claras y seguro incluido.`,
  une_plateforme_d__changes_europ_enne_r_serv_e_aux_: `Una plataforma de intercambio europea reservada a los anfitriones de Airbnb`,
  club_priv__pour_h_tes_not_s_4_5____un_abonnement_u: `Club privado para huéspedes con calificación 4.5+: una suscripción única para intercambiar en toda Europa.`,
  r_serv__aux_h_tes_airbnb_avec_une_note_sup_rieure_: `Reservado para anfitriones de Airbnb con una calificación superior o igual a 4,5.`,
  r_duction_de_50__en_2026__25eur_an_au_lieu_de_50eu: `Reducción del 50% en 2026: 25 EUR/año en lugar de 50 EUR/año. Precio garantizado de por vida para las 1000 primeras inscripciones.`,
  basse_saison__pause__rencontres_entre_h_tes__conom: `Temporada baja, escapadas, reuniones entre huéspedes, ahorro en vacaciones: todo está pensado para los huéspedes activos en Europa.`,
  voyagez_moins_cher__5__de_frais___h_bergez_sans_fr: `Viaja más barato (5% de tarifas), hospeda gratis (0%). El modelo más justo del mercado.`,
  fini_les_commissions_de_15__ou_plus__avec_traveltr: `No más comisiones del 15% o más. Con DONKEY TRAVEL, los anfitriones no pagan tarifas. Los viajeros pagan sólo el 5% de tarifa de servicio. Eso es justicia.`,
  hypoth_se_comparatif__booking_commission_h_te_15__: `Hipótesis comparativa: Comisión de anfitrión de reserva del 15% (según país y programa), modalidad solo anfitrión de Airbnb del 15,5% del lado del anfitrión y 0 del lado del viajero.`,
  les_frais_de_5__peuvent__tre_d_ductibles_de_vos_ch: `La tarifa del 5% puede ser deducible de tus gastos si eres una empresa. El modelo 0% simplifica la contabilidad personal.`,
  avec_traveltrok__vous_pouvez_baisser_le_prix_de_vo: `Con DONKEY TRAVEL, podrás bajar el precio de tus alquileres para alquilar con más frecuencia. Sus tarifas de anfitrión permanecen fijas, por lo que su red sigue siendo sólida.`,
  en_moyenne__c_est_environ___annualhostcase_average: `De media, el ahorro anual ronda los {{savings}}EUR en comparación con las plataformas basadas en comisiones.`,
  hypoth_ses__100eur_la_nuit__30eur_de_m_nage__dur_e: `Supuestos: 100EUR por noche, 30EUR limpieza, duración media 3 noches, 50% tasa de reserva anual.`,
  traveltrok_collecte_uniquement_les_donn_es_n_cessa: `DONKEY TRAVEL sólo recopila los datos necesarios para el funcionamiento del servicio: cuenta, perfil, intercambios y soporte.`,
  vos_donn_es_ne_sont_partag_es_qu_avec_les_services: `Tus datos solo se comparten con servicios técnicos esenciales (autenticación, alojamiento, seguridad) y nunca se revenden.`,
  vous_pouvez_demander_la_mise___jour_ou_la_suppress: `Puede solicitar actualizar o eliminar sus datos personales de su cuenta o comunicarse con el soporte.`,
  "help.faq.q1.question": "¿Cuánto cuesta la suscripción?",
  "help.faq.q1.answer":
    "50€/año para el plan clásico. Hay un descuento de lanzamiento a 25€/año para 2026.",
  "help.faq.q2.question": "¿Puedo intercambiar sin tener las mismas fechas?",
  "help.faq.q2.answer":
    "Absolutamente. Nuestro sistema flexible de intercambio permite que el anfitrión 1 vaya a la casa del anfitrión 2 en julio, y el anfitrión 2 vaya a la casa del anfitrión 1 en septiembre, de forma asincrónica.",
  "help.faq.q3.question":
    "¿El sitio está realmente reservado para anfitriones con una calificación de 4.5 y superior?",
  "help.faq.q3.answer":
    "Sí. Donkey Travel es un club cerrado. Al registrarse, verificamos el enlace a su anuncio de Airbnb para asegurarnos de que su calificación promedio sea de al menos 4.5/5 y que tenga reseñas.",
  "help.faq.q4.question": "¿Cómo se organizan los intercambios?",
  "help.faq.q4.answer":
    "No hay un sistema de puntos. Los miembros deciden por sí mismos cuántas noches quieren intercambiar basándose en el precio que indican. El anuncio de Airbnb sirve como referencia para verificar si la propuesta es justa y creíble.",
  "help.faq.q5.question": "¿Hay cargos adicionales (limpieza, servicio)?",
  "help.faq.q5.answer":
    "¡No! El principio de Donkey Travel es un intercambio 100% gratuito entre anfitriones. El anfitrión que recibe prepara el alojamiento, y el huésped lo devuelve en un estado impecablemente limpio (o gestiona la limpieza con el anfitrión según sus acuerdos).",
  "help.faq.q6.question": "¿Puedo vincular múltiples anuncios de Airbnb?",
  "help.faq.q6.answer":
    "Sí, esto está planeado en nuestras próximas actualizaciones para permitirte sincronizar múltiples alojamientos y ganar aún más oportunidades de intercambio.",
  "help.faq.q7.question": "¿Qué pasa si se cancela un intercambio?",
  "help.faq.q7.answer":
    "En caso de cancelación, le invitamos a comunicarse con su anfitrión a través de nuestra mensajería interna para encontrar un nuevo acuerdo o nuevas fechas.",
  "help.faq.q8.question": "¿Cómo se garantizan la confianza y la seguridad?",
  "help.faq.q8.answer":
    "Al aceptar solo anfitriones confirmados (calificación > 4.5), nos aseguramos de que todos los miembros sepan lo que significa 'alojar'. Además, la identidad y los anuncios son verificados por nuestro equipo.",
};
